<div
    style="
        max-width: 800px;
        margin: 0 auto;
        padding: 80px 80px;
        border: 1px solid #ccc;
        border-radius: 10px;
        font-family: Arial, Helvetica, sans-serif;
        color: #000 !important;
    "
>
    <div style="display: flex; justify-content: space-between">
        <div
            style="
                flex-basis: 50%;
                font-size: 16px;
                font-weight: 600;
                padding: 3px 5px;
                border: 1px solid #000;
                border-bottom: none;
            "
        >
            OUTCOME
        </div>
        <div
            style="
                flex-basis: 50%;

                border: 1px solid #000;
                border-left: none;
                border-bottom: none;
                padding-left: 15px;
                display: flex;
                align-items: center;
            "
        >
            {{ interviewDetails?.outcomeStatus }}
            <!-- <input
                        style="
                            background-color: transparent;
                            border: none;
                            outline: none;
                            height: 100%;
                            width: 100%;
                        "
                        [value]="interviewDetails?.outcome"
                    /> -->
        </div>
    </div>

    <div style="display: flex; justify-content: space-between">
        <div
            style="
                flex-basis: 50%;
                font-size: 16px;
                font-weight: 600;
                padding: 3px 5px;
                border: 1px solid #000;
                border-bottom: none;
            "
        >
            Student name
        </div>
        <div
            style="
                flex-basis: 50%;

                border: 1px solid #000;
                border-left: none;
                border-bottom: none;
                padding-left: 15px;
                display: flex;
                align-items: center;
            "
        >
            {{ interviewDetails?.studentName }}
            <!-- <input
                        style="
                            background-color: transparent;
                            border: none;
                            outline: none;
                            height: 100%;
                            width: 100%;
                        "
                        [value]="interviewDetails?.studentName"
                    /> -->
        </div>
    </div>
    <div style="display: flex; justify-content: space-between">
        <div
            style="
                flex-basis: 50%;
                font-size: 16px;
                font-weight: 600;
                padding: 3px 5px;
                border: 1px solid #000;
                border-bottom: none;
            "
        >
            CU Application ID
        </div>
        <div
            style="
                flex-basis: 50%;

                border: 1px solid #000;
                border-left: none;
                border-bottom: none;
                padding-left: 15px;
                display: flex;
                align-items: center;
            "
        >
            {{ interviewDetails?.studentId }}
            <!-- <input
                        style="
                            background-color: transparent;
                            border: none;
                            outline: none;
                            height: 100%;
                            width: 100%;
                        "
                        [value]="interviewDetails?.studentId"
                    /> -->
        </div>
    </div>

    <div style="display: flex; justify-content: space-between">
        <div
            style="
                flex-basis: 50%;
                font-size: 16px;
                font-weight: 600;
                padding: 3px 5px;
                border: 1px solid #000;
                border-bottom: none;
            "
        >
            Interviewer name
        </div>
        <div
            style="
                flex-basis: 50%;

                border: 1px solid #000;
                border-left: none;
                border-bottom: none;
                padding-left: 15px;
                display: flex;
                align-items: center;
            "
        >
            {{ interviewDetails?.interviewerName }}
            <!-- <input
                        style="
                            background-color: transparent;
                            border: none;
                            outline: none;
                            height: 100%;
                            width: 100%;
                        "
                        [value]="interviewDetails?.interviewerName"
                    /> -->
        </div>
    </div>

    <div style="display: flex; justify-content: space-between">
        <div
            style="
                flex-basis: 50%;
                font-size: 16px;
                font-weight: 600;
                padding: 3px 5px;
                border: 1px solid #000;
            "
        >
            Date of Interview
        </div>
        <div
            style="
                flex-basis: 50%;
                border: 1px solid #000;
                border-left: none;
                padding-left: 15px;
                display: flex;
                align-items: center;
            "
        >
            {{ today | date : "MM-dd-yyyy" }}
            <!-- <input
                        style="
                            background-color: transparent;
                            border: none;
                            outline: none;
                            height: 100%;
                            width: 100%;
                        "
                        [value]="today | date : 'MM-dd-yyyy'"
                    /> -->
        </div>
    </div>
    <div style="margin-top: 20px; font-size: 18px; font-weight: 600">
        <div style="display: flex; align-items: end; column-gap: 5px">
            <p style="margin: 0">
                Hello, my name is
                <span style="padding-left: 10px">{{
                    interviewDetails?.interviewerName
                }}</span>
            </p>

            ,

            <p style="margin: 0; padding-top: 5px">
                I will be conducting your interview today.
            </p>
        </div>

        <p
            style="
                padding-top: 20px;
                margin: 0;
                font-size: 18px;
                font-weight: 800;
            "
        >
            Can you hear me clearly? (Terminate and rearrange call if answer is
            no)
        </p>
        <p
            style="
                padding-top: 20px;
                margin: 0;
                font-size: 14px;
                line-height: 1.3;
            "
        >
            I will be asking you a number of questions to help us determine your
            suitability for a course with Coventry University. If you do not
            understand a question, or would like me to repeat or rephrase it,
            please ask me. Our conversation will be recorded, and I will be
            typing your answers as you talk.
        </p>
        <p
            style="
                padding-top: 20px;
                margin: 0;
                font-size: 18px;
                line-height: 1.3;
            "
        >
            *Take screenshot of applicant and close-up of their passport
        </p>

        <img
            [src]="blob"
            width="100%"
            height="400px;"
            style="min-height: 400px"
        />

        <p style="margin: 0; font-size: 18px; line-height: 1.3">
            [INSERT IMAGE OF STUDENT + SCREENSHOT OF THE PASSPORT]
        </p>
        <h4>
            <br />The interview will take approximately 30 minutes. Are you
            ready to start the interview?
            {{ questionAnswer[0]?.radioData[1].answer }}
        </h4>

        <h4 style="padding-top: 20px; margin: 0">
            Please can you tell me your full name and date of birth?
        </h4>
        <div style="display: flex; margin-bottom: 20px">
            <div>
                <p>Name : {{ interviewDetails?.studentName }}</p>
            </div>
            <div style="padding-left: 20px">
                <p>DOB : {{ interviewDetails?.dob }}</p>
            </div>
        </div>
        <h4 style="margin-top: 20px">
            Which course have you applied to study at Coventry University?
            {{ questionAnswer[5]?.radioData[1].answer }}
        </h4>
        <p style="margin-bottom: 20px">
            Course: {{ interviewDetails?.courseName }}
        </p>
    </div>

    <h4>
        What does (BA, BSc, MA, MSc) stand for?
        {{ questionAnswer[0]?.radioData[4].answer }}
    </h4>

    <table
        style="border-collapse: collapse; text-align: left; margin-top: 20px"
    >
        <thead style="padding: 5px; vertical-align: top; font-weight: 500">
            <th style="width: 5%; border: 1px solid #000; padding: 5px"></th>
            <th style="width: 20%; border: 1px solid #000; padding: 5px">
                Question
            </th>
            <th style="width: 55%; border: 1px solid #000; padding: 5px">
                Answer
            </th>
            <th style="width: 10%; border: 1px solid #000; padding: 5px">
                Risk 10- low, 1- high
            </th>
        </thead>

        <tbody style="vertical-align: top">
            <ng-container
                *ngFor="
                    let questionAnswer of questionAnswer[0]
                        ?.complusoryQuestionList;
                    index as i
                "
            >
                <tr>
                    <td style="border: 1px solid #000; text-align: center">
                        {{ i + 3 }}
                    </td>
                    <td
                        style="
                            font-size: 16px;
                            padding: 5px 10px;
                            padding-bottom: 20px;
                            border: 1px solid #000;
                            font-weight: 500px;
                        "
                        [innerHTML]="questionAnswer?.question"
                    ></td>
                    <td
                        style="
                            height: 100%;
                            border: 1px solid #000;
                            padding: 0;
                            margin: 0;
                            overflow: hidden;
                            padding: 5px 10px;
                        "
                        [innerHTML]="questionAnswer?.answer"
                    ></td>

                    <td
                        style="
                            height: 100%;
                            border: 1px solid #000;
                            vertical-align: middle;
                        "
                    >
                        <div
                            style="
                                border: none;
                                outline: none;
                                height: 40px;
                                width: 50px;
                                margin-left: 10%;
                                text-align: center;
                                font-weight: 600;
                            "
                            [innerHtml]="questionAnswer?.risk"
                        ></div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>

    <div style="margin-top: 20px">
        <h4 style="margin: 0; margin-bottom: 20px">
            If we have any further questions about the answers you have given,
            you will be invited to provide further documentation or invited to a
            more in-depth interview.
        </h4>
        <h4 style="margin: 0; margin-bottom: 20px">
            You can expect to receive an outcome within 5 working days.
        </h4>

        <h4
            style="
                margin: 0;

                margin-bottom: 20px;
            "
        >
            Thank you for your time. Do you have any questions for me?
        </h4>
    </div>

    <table style="width: 100%; border-collapse: collapse">
        <tbody>
            <tr>
                <td
                    style="border: 1px solid black; padding: 8px; width: 100%"
                    colspan="2"
                >
                    International Student Support Team assessment use only
                </td>
            </tr>
            <tr>
                <td
                    style="border: 1px solid black; padding: 8px; width: 100%"
                    colspan="2"
                >
                    Student answered questions sufficiently (delete as
                    appropriate):
                </td>
            </tr>
            <tr>
                <td
                    style="border: 1px solid black; padding: 8px; width: 100%"
                    colspan="2"
                >
                    {{ questionAnswer[0].answersufficiency?.answer }}
                </td>
            </tr>
            <tr>
                <td
                    style="border: 1px solid black; padding: 8px; width: 100%"
                    colspan="2"
                >
                    If 'Yes', address any risk areas scoring below 6 (for
                    non-High Risk) or 7 (for High Risk) raised in interview. If
                    "No" please comment below
                </td>
            </tr>
            <tr>
                <td
                    style="border: 1px solid black; padding: 8px; width: 100%"
                    colspan="2"
                    [innerHTML]="questionAnswer[0].riskArea?.answer"
                ></td>
            </tr>
            <tr>
                <td style="border: 1px solid black; padding: 8px; width: 50%">
                    Reviewer Name:
                </td>
                <td
                    style="border: 1px solid black; padding: 8px; width: 50%"
                    [innerHTML]="interviewDetails?.interviewerName"
                ></td>
            </tr>
            <tr>
                <td style="border: 1px solid black; padding: 8px; width: 50%">
                    Date of Review:
                </td>
                <td style="border: 1px solid black; padding: 8px; width: 50%">
                    {{ today | date : "MM-dd-yyyy" }}
                </td>
            </tr>
        </tbody>
    </table>
</div>
